// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: require('../../package.json').version + '-dev',
  Version: require('../../package.json').version,
    // apiUrl: 'https://dev.api.b2b.selt.com/',
    // apiUrl: 'https://prod.api.b2b.selt.com/',
      apiUrl: 'http://dev-prod3.api.b2b.selt.com/',
    // apiUrl: 'http://localhost:8055/', 
    //  apiUrl: 'http://localhost:56970/', 
    // apiUrl: 'http://54.38.193.200:8054/',
  

  
  allPosition: true,
  //versionCheckURL: 'http://localhost:4300/assets/js/version.json',
  versionCheckURL: './assets/js/version.json',
  isDevVersion: true,
  InspectorActive: false,
  useParts: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
